module.exports = __webpack_public_path__ + "img/act_pro_img12s_03.ccf306e1.png";